export default __webpack_public_path__ + "static/media/ale.c63daa43.jpg";